<template>
  <div class="markdown_wrapper">
    <div>
      <mavon-editor
        ref="md"
        class="mavon-editor"
        v-model="value"
        :toolbars="toolbars"
        :ishljs="true"
        :box-shadow="false"
        :subfield="true"
        :tabSize="4"
        :navigation="false"
        :toolbarsFlag="true"
        @change="changeMardown"
        @save="SaveMarkdown"
        @imgAdd="imgAdd"
        @imgDel="imgDel"
        @fullScreen="fullScreen"
        :toolbarsBackground="'white'"
        :placeholder="'开始编辑...按ESC键退出...'"
      ></mavon-editor>
    </div>
  </div>
</template>

<script>
import uploadFileBlob from "@/config/uploadFileBlob";
import { dateFormatName } from "@/config/_filter";

export default {
  name: "markdown",
  props: {
    markdown: String,
  },
  data() {
    return {
      value: "",
      drawer: false,
      direction: "rtl",

      //图片上传
      uploadFileTime: false,

      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        underline: true, // 下划线
        strikethrough: true, // 中划线
        mark: true, // 标记
        superscript: true, // 上角标
        subscript: true, // 下角标
        quote: true, // 引用
        ol: true, // 有序列表
        ul: true, // 无序列表
        link: true, // 链接
        imagelink: true, // 图片链接
        code: true, // code
        table: true, // 表格
        fullscreen: false, // 全屏编辑
        readmodel: true, // 沉浸式阅读
        htmlcode: false, // 展示html源码
        help: true, // 帮助
        /* 1.3.5 */
        undo: true, // 上一步
        redo: true, // 下一步
        trash: true, // 清空
        save: true, // 保存（触发events中的save事件）
        /* 1.4.2 */
        navigation: false, // 导航目录
        /* 2.1.8 */
        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true, // 右对齐
        /* 2.2.1 */
        subfield: true, // 单双栏模式
        preview: true, // 预览
      },
      Editor_Height: "",
    };
  },

  mounted() {
    this.Editor_Height = "100px";
    this.value = this.markdown;
    console.log(this.value);
    console.log(this.markdown);

    console.log("MARKDOWN传值");
  },
  watch: {
    value(val) {
      if (val != "") {
        this.getcode();
      }
    },
  },
  methods: {
    fullScreen() {
      console.log("全屏按钮");
    },

    getcode() {
      this.$nextTick(() => {
        const hljsElements = document.getElementsByClassName("hljs");
        for (let i = 0; i < hljsElements.length; i++) {
          const hljsElement = hljsElements[i];
          //   // 判断当前元素下是否存在.line-num-box元素
          const lineNumBoxElement = hljsElement.querySelector(".line-num-box");
          if (!lineNumBoxElement) {
            const code = document.querySelectorAll("pre code");
            code.forEach((item) => {
              console.log(item, 4122123);
              console.log(item.offsetHeight, 4122123);

              // let pre = item.parentElement;
              // 新建元素 代码块序号

              let lineNumBox = document.createElement("div");
              lineNumBox.setAttribute(
                "style",
                "height: " + item.offsetHeight + "px"
              );
              lineNumBox.setAttribute(
                "style",
                "float: left;  padding:0 5px; border-right: 1px solid #ccc;  margin-right: 5px;"
              );

              lineNumBox.className = "line-num-box";
              let num = ""; // 设行高二十
              for (let i = 1; i <= Math.ceil(item.offsetHeight / 20); i++) {
                num += i + "\n"; // 序号加上换行符
              }
              lineNumBox.innerText = num; // 插入序号
              item.parentElement.insertBefore(lineNumBox, item);
            });
          }
        }
      });
    },
    changeMardown(val) {
      console.log(val, 45122);
      this.$emit("changeMardown", val);
    },
    SaveMarkdown(val, render) {
      console.log("保存markdown");
      console.log(val);
      console.log(render);

      this.$emit("SaveMarkDown", val, render);
      this.$message.success("已保存!");
      this.drawer = false;
    },
    SaveHtmlCode(val, render) {
      console.log("保存htmlcode");
      console.log(val);
      console.log(render);
    },

    imgAdd(pos, file) {
      console.log(pos);
      console.log(file);
      console.log(file.miniurl.split(",")[1]);

      var that = this;
      uploadFileBlob(
        Buffer.from(file.miniurl.split(",")[1], "base64"),
        "static/markdown/images/" + dateFormatName() + ".png",
        function(res) {
          console.log("上传成功");
          console.log(res);

          if (res.url) {
            that.$refs.md.$img2Url(pos, res.url);

            console.log(res.url);
          } else {
            that.$message.warning("上传失败");
          }
        }
      );
    },
    imgDel() {},

    uploadFileBlob() {},

    handleClose(done) {
      this.$confirm("记得保存文档哦!")
        .then((res) => {
          console.log(res);
          done();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.markdown_wrapper {
  border: 1px solid rgb(223, 222, 222);

  /deep/.content-input-wrapper {
    overflow: hidden;
    height: calc(100vh - 410px);
  }

  /deep/.content-input-wrapper::-webkit-scrollbar {
    display: none; /* 隐藏滚动条 */
  }

  /deep/.auto-textarea-wrapper .auto-textarea-input {
    height: calc(100vh - 420px);
    overflow-y: scroll;
  }
  /deep/.auto-textarea-wrapper .auto-textarea-input::-webkit-scrollbar {
    display: none; /* 隐藏滚动条 */
  }

  /deep/.v-note-wrapper .v-note-panel .v-note-show .v-show-content {
    height: calc(100vh - 420px);
    overflow-y: scroll;
  }

  /deep/.v-note-wrapper
    .v-note-panel
    .v-note-show
    .v-show-content::-webkit-scrollbar {
    display: none; /* 隐藏滚动条 */
  }
}

// /deep/ .line-num-box {
//     float: left;
//     padding: 0 5px;
//     border-right: 1px solid #ccc;
//     margin-right: 5px;
// }
</style>
